module.exports = ".approvals-border {\n  border-left: 5px solid; }\n  .approvals-border.aprovacao-pendente {\n    border-left-color: #ffc107; }\n  .approvals-border.pagamento-pendente {\n    border-left-color: red; }\n  .approvals-border.pago {\n    border-left-color: #2ecc71; }\n  .big-modal {\n  width: 1000px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/approvals/approvals.component.scss
// module id = ./src/app/views/approvals/approvals.component.scss
// module chunks = main